import { Box, Divider, Stack, Typography } from '@mui/joy';
import type { ReactElement, ReactNode } from 'react';
interface TwoThirdsLayoutProps {
  left: ReactNode;
  right?: ReactNode;
  spacing?: number;
  title?: string;
  withDivider?: boolean;
  fullHeight?: boolean;
}
// This component uses custom grid to avoid problems with negative margins which cause overflow
export const TwoThirdsLayout = ({
  left,
  right,
  spacing = 1.5,
  title,
  withDivider = false,
  fullHeight,
}: TwoThirdsLayoutProps): ReactElement => {
  return (
    <Stack justifyContent="space-between" width="100%" alignItems="stretch" height={fullHeight ? '100%' : undefined}>
      {title && <Typography level="title-md">{title}</Typography>}
      <Box
        display="grid"
        sx={{
          gridTemplateColumns: {
            xs: '1fr',
            lg: withDivider ? '8fr 1px 4fr' : '8fr 4fr',
          },
          gap: spacing / 2,
          paddingBottom: 2,
          height: fullHeight ? '100%' : undefined,
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            height: fullHeight ? '100%' : undefined,
            minHeight: 0,
            minWidth: 0,
          }}
        >
          {left}
        </Box>
        {withDivider && (
          <Divider
            orientation="vertical"
            sx={{
              display: {
                xs: 'none',
                lg: 'block',
              },
            }}
          />
        )}
        {right && (
          <Box
            sx={{
              height: fullHeight ? '100%' : undefined,
              minHeight: 0,
              minWidth: 0,
            }}
          >
            {right}
          </Box>
        )}
      </Box>
    </Stack>
  );
};
